import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const ReferralBar = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-yellow-100 text-yellow-800 p-4 rounded shadow mt-6">
        ⚠️ Referral source data is missing.
      </div>
    );
  }

  const referralSources = ['Website', 'Psychology Today', 'Community Health', 'Clients'];
  const counts = referralSources.map(
    (source) => data.find((d) => d.source === source)?.count || 0
  );

  const chartData = {
    labels: referralSources,
    datasets: [
      {
        label: 'Referral Source Count',
        data: counts,
        backgroundColor: '#3B82F6',
        borderRadius: 6,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: { beginAtZero: true },
    },
  };

  return (
    <div className="bg-white rounded shadow p-4 mt-6">
      <h2 className="text-lg font-semibold mb-4">Referral Sources</h2>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default ReferralBar;
